import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type QuoteRequestLineCustomInputsDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.findCustomInputsBulk
>;

export const fetchCustomInputsBulk = async (
  quoteRequestId: string | undefined,
): Promise<QuoteRequestLineCustomInputsDto | null> => {
  if (!quoteRequestId) {
    return null;
  }

  const response = await api.quoteRequestLines.findCustomInputsBulk.query({
    query: { quoteRequestId },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
